const getDynamicConfigValue = (name) => {
    return window._env_[name];
};

export { getDynamicConfigValue };
//# sourceMappingURL=dynamicConfig.js.map
